<!-- 党建专栏 -->
<template>
  <div class="pageView">
    <PCNavbar />
    <CarouselHome type="partyBuilding" />
    <div class="main-wrap">
      <div class="block-wrap">
        <div class="tab">
          <div class="tab-item" :class="{ current: current == index + 1 }" @click="toggle(index + 1)" v-for="(item, index) in fenlei" :key="index">{{ item.name }}</div>
          <!-- <div class="tab-item" :class="{ current: current == 2 }" @click="toggle(2)">党建活动</div> -->
        </div>
        <div class="article" v-show="current == 1">
          <h3 class="h3">{{ detail.title }}</h3>
          <div class="box content" v-html="detail.content"></div>
        </div>
        <div class="article" v-show="current == 2">
          <div class="list" v-if="list.length">
            <div class="list-box" v-for="(item, index) in list" :key="index" @click="handleToDetails(item)">
              <el-image :src="item.image" class="img" />
              <div class="info">
                <div class="title">{{ item.title }}</div>
                <div class="time">{{ item.time }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination" v-show="current == 2">
          <el-pagination ref="pagination" layout="slot" :total="total" :current-page="page" hide-on-single-page>
            <div>
              <el-button type="text" class="custom-btn" :disabled="page <= 1" @click="handlePrevChange">
                <i class="el-icon-arrow-left"></i>
                上一页
              </el-button>
              <el-button type="text" class="custom-btn" :disabled="page >= lastPage" @click="handleNextChange">
                下一页
                <i class="el-icon-arrow-right"></i>
              </el-button>
            </div>
          </el-pagination>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { formatDate } from "@/utils/tools";
import PCNavbar from "@/components/navbar/index";
import CarouselHome from "@/components/carousel_home/index";
import Footer from "@/components/footer/index";

export default {
  name: "PartyBuilding",
  components: { PCNavbar, CarouselHome, Footer },
  data() {
    return {
      current: 1,
      list: [],
      detail: {},
      page: 1,
      total: 0,
      lastPage: 1,
      fenlei: []
    };
  },
  watch: {
    // $route(to) {
    //   const index = to.params.id || 1;
    //   this.toggle(index);
    // },
  },
  async created() {
    this.getFenlei()
    this.$watch(
      "$route",
      (to) => {
          const index = to.params.id || 1;
          this.toggle(index);
      },
      { immediate: true }
    );
  },
  methods: {
    toggle(index) {
      this.current = index;
      if (index == 1) {
        this.getDetail();
      } else {
        this.page = 1;
        this.getList();
      }
      this.$store.dispatch("setMenuActive", "/partyBuilding?type=" + index);
      // 更新路由参数
      this.$router.push({
        path: "/partyBuilding/" + index,
      });
    },
    async getFenlei() {
      const res = await CifuAPI.getArticleType({ model_type: "dzb_activity" });
      if (res.code == 1) {
        this.fenlei = res.data;
      }
    },

    async getDetail() {
      const res = await CifuAPI.getArticleDetail({ unicode: "dangzhibujieshao" });
      this.detail = res.data;
    },
    async getList() {
      const res = await CifuAPI.getArticleList({ model_type: "dzb_activity", limit: 5, page: this.page });
      if (res.code == 1) {
        res.data.data.forEach((item) => {
          item.time = formatDate(item.show_time, "YYYY.MM.DD");
        });
        this.list = res.data.data;
      }
    },
    handlePrevChange() {
      const index = this.current;
      this.page--;
      this.toggle(index);
    },
    handleNextChange() {
      const index = this.current;
      this.page++;
      this.toggle(index);
    },
    handleToDetails(item) {
      if (item.gzh_url) {
        window.open(item.gzh_url, 'blank');
      } else if (item.outlink) {
        window.open(item.outlink, 'blank');
      } else {
        this.$router.push(`/partyBuildingDetail?id=${item.id}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pageView{
  width: 100%;
  min-width: 1400px;
}
.article {
  padding-top: 50px;
  @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    padding-top: 20px;
  }
  .h3 {
    padding-top: 10px;
    font-size: 28px;
    color: #663301;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      padding-top: 0;
      font-size: 16px;
    }
  }
  .box {
    padding: 50px 0;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      padding: 20px 0;
    }
  }
  content {
    font-size: 18px;
    color: #828282;
    line-height: 32px;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      font-size: 12px;
      line-height: 20px;
    }
  }
}
.info{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .time{
    padding-bottom: 10px;
  }
}
</style>
